import type { BadgeOption } from '../../enums/BadgeOptions';
import { BADGE_OPTIONS } from '../../enums/BadgeOptions';
import type { BadgeMetadata } from './types';

export const badgeMetadata: Record<BadgeOption, BadgeMetadata> = {
  [BADGE_OPTIONS.Connected]: { label: 'Connected', background: '#EBFFEF', textColor: '#4FBA80' },
  [BADGE_OPTIONS.NotSupported]: { label: 'Coming soon', background: '#3A78F814', textColor: '#3A78F8' },
};
